import { useEffect, useState } from 'react';
import { toApiError, type ApiError } from './apiError';

/**
 * Übersetzt einen Query-Fehler in die Problemform des Servers. Ansichten nennen damit dessen
 * Grund, statt nur „konnte nicht geladen werden" zu sagen.
 */
export function useApiProblem(error: unknown): ApiError | null {
  const [problem, setProblem] = useState<ApiError | null>(null);
  useEffect(() => {
    if (!error) {
      setProblem(null);
      return;
    }
    let cancelled = false;
    void toApiError(error).then((value) => {
      if (!cancelled) setProblem(value);
    });
    return () => {
      cancelled = true;
    };
  }, [error]);
  return problem;
}
